import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ChapterLabel } from "./ChapterLabel";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "What if I already have someone doing my marketing?",
    a: "This isn't a replacement — it's a second set of eyes. It often catches things people too close to the business miss.",
  },
  {
    q: "How long until I see results?",
    a: "Most clients see clear insights in the first report, with measurable improvements within the first 1-2 months.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes — it's month-to-month with no long-term contract.",
  },
  {
    q: "Do I need to do anything technical?",
    a: "No. We handle the review and reporting — you just get the walkthrough.",
  },
  {
    q: "Who exactly do you work with?",
    a: "Service-based local businesses — contractors, plumbers, HVAC, electricians, landscapers, and similar trades. If your customers find you on Google, we can help.",
  },
  {
    q: "What if I don't have a website?",
    a: "No problem. Your Google Business Profile and lead response speed still get reviewed — and if you need one, we build fast, mobile-first websites for service businesses.",
  },
  {
    q: "Do you build websites too?",
    a: "Yes — and it's included. Every Monthly ($199/mo) and Annual ($2,000/yr) plan comes with a full website design & build plus ongoing management. Only want a website or an app? There's a plan for that too: $500 one-time + $50/month, fully managed.",
  },
  {
    q: "Is my payment and business data secure?",
    a: "Yes. Payments run through Stripe — we never see or store your card details. Your reports and business data are only visible to you.",
  },
  {
    q: "What actually happens on the free call?",
    a: "We run a free audit of your online presence first, then spend 15 minutes showing you what's working and what's costing you customers. You keep the findings either way.",
  },
];

export const Faq = () => (
  <section id="faq" className="py-24 sm:py-32" data-testid="faq-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <ChapterLabel text="Chapter 08 // Answers" />
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-4">
          <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-tight text-white">
            Frequently Asked Questions
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-7 lg:col-start-6">
          <Accordion type="single" collapsible data-testid="faq-accordion-container" className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-white/10"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="text-left font-display text-lg sm:text-xl font-semibold text-white hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-slate-400 leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
